module.exports = __webpack_public_path__ + "img/chance-cards.491bfa65.png";